import axios from '../utils/axios';

export async function getRiders(): Promise<any[]> {
  return axios.get('/riders').then((res) => res.data);
}

export async function getRider(riderId: string): Promise<any> {
  return axios.get(`/riders/${riderId}`).then((res) => res.data);
}

export async function createRider(rider: any): Promise<any> {
  return axios.post('/riders', rider).then((res) => res.data);
}

export async function updateRider(riderId: string, rider: any): Promise<any> {
  return axios.put(`/riders/${riderId}`, rider).then((res) => res.data);
}

export async function deleteRider(riderId: string): Promise<any> {
  return axios.delete(`/riders/${riderId}`).then((res) => res.data);
}
